import { render, staticRenderFns } from "./GlobalSearchFilteredProvider.vue?vue&type=template&id=7fefe6fa&"
import script from "./GlobalSearchFilteredProvider.vue?vue&type=script&lang=ts&"
export * from "./GlobalSearchFilteredProvider.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports